import React, { useEffect, useState } from 'react';
import DineInKitchenCard from './dine-in-kitchen-card';
import PageText from 'components/base/page-text';
import { CoKitchenType } from 'utils/types';
import useDashboardContext from 'contexts/dashboard.context';
import { ENUM_COKITCHEN_STATUS } from 'utils/enum';

const DineInKitchenList = () => {
  const { searchValue, cokitchens } = useDashboardContext();
  const [filteredCokitchens, setFilteredCokitchens] = useState<CoKitchenType[]>([]);

  useEffect(() => {
    if (!searchValue) {
      setFilteredCokitchens(
        cokitchens.filter((item) => item.cokitchen_type === ENUM_COKITCHEN_STATUS.DINE_IN)
      );
      return;
    }
    setFilteredCokitchens(
      cokitchens.filter(({ name }) => name.toLowerCase().includes(searchValue.toLowerCase()))
    );
  }, [searchValue, cokitchens]);

  return (
    <div>
      {filteredCokitchens.length === 0 ? (
        <PageText
          text={
            searchValue
              ? 'No dine-in kitchens match your searchValue'
              : 'No Dine in kitchens available'
          }
        />
      ) : (
        <div className='grid md:grid-cols-3 grid-cols-4 gap-6'>
          {filteredCokitchens.map((item: CoKitchenType, index: number) => (
            <DineInKitchenCard key={index} data={item} />
          ))}
        </div>
      )}
    </div>
  );
};

export default DineInKitchenList;
